import { Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const FilterDisplay = ({ filterOptions, origin }) => {

    let { calenderMonthFilter } = useSelector((state) => state.calendarData);

    let selectedRoles, selectedSortBy, selectedSortOrder, filterStatus;

    if (origin === "contacts") {
        ({ selectedRoles, selectedSortBy, selectedSortOrder, filterStatus } = filterOptions || {});
    }
    const contactFilters = origin === "contacts" ? [selectedRoles, selectedSortBy, selectedSortOrder, filterStatus].filter(Boolean) : [];

    return <>
        {origin === "bugsTable" ?
            <Tag
                style={{
                    padding: "2px 5px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    margin: "2px",
                    borderRadius: "16px",
                    lineHeight: "17px",
                }}
                color="blue"
            >
                {filterOptions?.filterByStatus}
            </Tag> :

            origin === "userTableView" ? (
                Object.entries(filterOptions || {})
                    .filter(([_, val]) =>
                        Array.isArray(val)
                            ? val.length > 0
                            : val !== "" && val !== null && val !== undefined
                    )
                    .map(([key, val]) => (
                        <Tag
                            key={key}
                            style={{
                                padding: "2px 5px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                margin: "2px",
                                borderRadius: "16px",
                                lineHeight: "17px",
                            }}
                            color="blue"
                        >
                            {Array.isArray(val) ? val.join(", ") : String(val)}
                        </Tag>
                    ))
            ) :
                origin === "calendar" ? calenderMonthFilter?.filter((el) => el?.selected)?.map((agent, index) => (
                    <Tag
                        style={{
                            padding: "2px 8px",
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            margin: "2px",
                            borderRadius: "16px",
                            lineHeight: "20px",
                        }}
                        key={index} color="blue"
                    >
                        <span>{agent?.fullName}</span>
                    </Tag>
                ))
                    :
                    origin === "contacts" ? contactFilters?.flatMap((filter) =>
                        Array.isArray(filter) ? filter : [filter]
                    ).map((item, index) => (
                        <Tag
                            style={{
                                padding: "2px 8px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                margin: "2px",
                                borderRadius: "16px",
                                lineHeight: "20px",
                            }}
                            key={index}
                            color="blue"
                        >
                            {item}
                        </Tag>
                    )) :
                        origin === "subscriptionLogs" ? (
                            Object.entries(filterOptions || {})
                                .filter(([key, val]) =>
                                    !["logType", "page", "limit"].includes(key) && (
                                        Array.isArray(val)
                                            ? val.length > 0
                                            : val !== "" && val !== null && val !== undefined
                                    )
                                )
                                .map(([key, val]) => (
                                    <Tag
                                        key={key}
                                        style={{
                                            padding: "2px 5px",
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            margin: "2px",
                                            borderRadius: "16px",
                                            lineHeight: "17px",
                                        }}
                                        color="blue"
                                    >
                                        {Array.isArray(val) ? val.join(", ") : String(val)}
                                    </Tag>
                                )))
                            :
                            origin === "ndaTable" ?
                                filterOptions?.map((filter, index) => (
                                    <Tag
                                        style={{
                                            padding: "2px 8px",
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            margin: "2px",
                                            borderRadius: "16px",
                                            lineHeight: "20px",
                                        }}
                                        key={index}
                                        color="blue"
                                    >
                                        {filter}
                                    </Tag>
                                ))
                                :
                                origin === "contentTable" ?
                                    filterOptions?.map((filter, index) => (
                                        <Tag
                                            style={{
                                                padding: "2px 8px",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                                margin: "2px",
                                                borderRadius: "16px",
                                                lineHeight: "20px",
                                            }}
                                            key={index}
                                            color="blue"
                                        >
                                            {filter === true ? "Deleted" : "Active"}
                                        </Tag>
                                    ))
                                    :
                                    null
        }
    </>
}

export { FilterDisplay }